import {loadScriptOnce} from './utils';

document.addEventListener('DOMContentLoaded', () => {
  loadScriptOnce('/local/templates/template3/public/js/vendor/jquery-3.2.1.min.js', function () {
    const $ = window.jQuery || window.$;

    if (!$) return;

    (function () {
      const $lang = $('.lang');

      if (!$lang.length) return;

      const $langList = $('.lang__list'),
        classOpen = '-open';
      let timer;

      $lang.on('click', function () {
        $(this).toggleClass(classOpen);
        $langList.slideToggle();
      });

      function closeMenu(event) {
        if (!$(event.target).closest($lang).length && $lang.hasClass(classOpen)) {
          $lang.removeClass(classOpen);
          $langList.slideToggle();
        }
      }

      function changeSizeTime(e) {
        if (timer) {
          window.clearTimeout(timer);
        }

        timer = window.setTimeout(function () {
          closeMenu(e);
        }, 100);
      }

      // close
      $(document).on('click', function (e) {
        closeMenu(e);
      });

      $(window).on('scroll resize', function (e) {
        changeSizeTime(e);
      });
    }());
  });
})
